export default __webpack_public_path__ + "static/media/simply-hunting-experience.2bfb7962.png";